module.exports = __webpack_public_path__ + "static/img/item1.3b5a32ab.png";